export default __webpack_public_path__ + "static/media/up-red.6a261a8c.svg";